/* footer-animation JavaScript/jQuery */
jQuery(function( $ ) {

    $('.accordion .collapse').find( '.card-body' ).children().each( function() {
        $( this ).css( { 'transition': 'all .5s ease' } );
    });

    $('.accordion .collapse').on('hidden.bs.collapse', function () {
        // do something…
        console.log( 'hidden' );
        $( this ).find( '.card-body' ).children().each( function() {
            $( this ).css( { 'opacity': '0', 'padding-left': '30px' } );
        });
    });

    $('.accordion .collapse').on('shown.bs.collapse', function () {
        // do something…
        console.log( 'shown' );
        $( this ).find( '.card-body' ).children().each( function() {
            let child = $( this );
            setTimeout( function() {
                console.log('show child');
                child.css( { 'opacity': '1', 'padding-left': '0px' } );
            }, ( child.index() * 500 ) );
        });
    });


});
